export const message = {
  FILL_REQUIRED_FIELD: "Please fill the required field",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
};

export const calculateDays = (start, end) => {
  if (!start || !end) return 0;
  const d1 = new Date(start);
  const d2 = new Date(end);
  const diffTime = Math.abs(d2 - d1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays + 1; // Including start date
};

export const calculateEndDate = (start, days) => {
  if (!start || !days) return "";
  const d = new Date(start);
  d.setDate(d.getDate() + parseInt(days) - 1);
  return d.toISOString().split("T")[0];
};

export const STATE_CODE_TO_NAME = {
  "01": "Jammu and Kashmir",
  "02": "Himachal Pradesh",
  "03": "Punjab",
  "04": "Chandigarh",
  "05": "Uttarakhand",
  "06": "Haryana",
  "07": "Delhi",
  "08": "Rajasthan",
  "09": "Uttar Pradesh",
  10: "Bihar",
  11: "Sikkim",
  12: "Arunachal Pradesh",
  13: "Nagaland",
  14: "Manipur",
  15: "Mizoram",
  16: "Tripura",
  17: "Meghalaya",
  18: "Assam",
  19: "West Bengal",
  20: "Jharkhand",
  21: "Odisha",
  22: "Chhattisgarh",
  23: "Madhya Pradesh",
  24: "Gujarat",
  25: "Daman and Diu",
  26: "Dadra and Nagar Haveli and Daman and Diu",
  27: "Maharashtra",
  28: "Andhra Pradesh (Before Bifurcation)",
  29: "Karnataka",
  30: "Goa",
  31: "Lakshadweep",
  32: "Kerala",
  33: "Tamil Nadu",
  34: "Puducherry",
  35: "Andaman and Nicobar Islands",
  36: "Telangana",
  37: "Andhra Pradesh",
  38: "Ladakh",
  97: "Other Territory",
  99: "Centre Jurisdiction",
};

export const getStateNameFromGstin = (gstin) => {
  if (!gstin || typeof gstin !== "string") return "";
  return STATE_CODE_TO_NAME[gstin.slice(0, 2)] || "";
};

export const getStateCodeFromGstin = (gstin) => {
  if (!gstin || typeof gstin !== "string") return "";
  return gstin.slice(0, 2);
};

// Build reverse lookup: lowercase state name → code
const STATE_NAME_TO_CODE = Object.entries(STATE_CODE_TO_NAME).reduce(
  (acc, [code, name]) => {
    acc[name.toLowerCase()] = code;
    return acc;
  },
  {},
);

/**
 * Strip common prefixes like "IN - " from a state name.
 * "IN - Karnataka" → "Karnataka"
 * "Haryana" → "Haryana"
 */
export const cleanStateName = (stateName) => {
  if (!stateName) return "";
  return String(stateName)
    .replace(/^IN\s*-\s*/i, "")
    .trim();
};

/**
 * Look up GST state code (e.g. "29") from a state name.
 * Handles both "Karnataka" and "IN - Karnataka".
 */
export const getStateCodeFromName = (stateName) => {
  const cleaned = cleanStateName(stateName).toLowerCase();
  if (!cleaned) return "";
  return STATE_NAME_TO_CODE[cleaned] || "";
};

